import React from 'react';
import { SparkFilterType } from 'components/Providers/ContextProviders/SparkSearchContextProvider';

export interface SparkSearchContextValue {
  getIsFilterButtonActive: (value: string) => boolean;
  handleFilterButtonClick: (value: string) => void;
  handleQueryChange: (value: string) => void;
  filter: SparkFilterType;
}

// Create a context with initial value as null
export const SparkSearchContext = React.createContext<
  SparkSearchContextValue | undefined
>(undefined);
